import React from "react";

import { useTranslation } from "react-i18next";

import Fade from 'react-reveal/Fade';

import main from '../../img/main.png'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="h-[60px] xl:h-[110px] bg-[#9D0032] flex items-center justify-center">
                <p className="manrope text-center text-[24px] sm:text-[30px] md:text-[36px] xl:text-[60px] font-[800] text-white">{t('home.1')}</p>
            </div>
            <div className="xl:h-[491px] bg-[#282A2D] relative flex flex-col-reverse md:flex-row justify-between items-center px-[20px] xl:px-[70px]">
                <Fade><img src={main} alt="" className="mt-[20px] md:mt-0"/></Fade>
                <div className="mt-[20px] md:mt-0 xl:max-w-[522px]">
                    <p className="manrope text-[20px] xl:text-[40px] text-white font-[500]">{t('home.2')}</p>
                    <p className="manrope text-[16px] xl:text-[25px] text-[#C5C5C5] font-[500] mt-[20px] xl:mt-[50px]">{t('home.2')}</p>
                    <p className="roboto text-[14px] font-[300] text-[#FFFFFFB2] mt-[10px] xl:mt-[30px] leading-[1.3]">{t('home.4')}</p>
                </div>
            </div>
        </div>
    );
}

export default Main;